import styles from './StatsCards.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { SvgIcon } from '../SvgIcon';
import { SvgIconSrc } from '../SvgIcon/SvgIcon.constants';
import classNames from 'classnames';
import {
  FiClock,
  FiCoffee,
  FiImage,
  FiPercent,
  FiTrendingUp,
} from 'react-icons/fi';

export const StatCard = ({
  title,
  value,
  subtitle,
  trend,
  children,
  contaninerClassName,
  icon,
  iconBg,
  compact,
}) => {
  return (
    <div
      className={classNames(styles.statCard, contaninerClassName, {
        [styles.statCard_compact]: compact,
      })}
    >
      <div className={styles.statHeader}>
        {icon && (
          <span
            className={styles.iconBadge}
            style={iconBg ? { background: `var(--${iconBg})` } : undefined}
          >
            {icon}
          </span>
        )}
        {title}
      </div>

      <div
        className={classNames(styles.statContent, {
          [styles.statContentCompact]: compact,
        })}
      >
        {children}

        <div className={styles.statText}>
          <div className={styles.value}>{value}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {trend && <div className={styles.trend}>{trend.text}</div>}
        </div>
      </div>
    </div>
  );
};

export const ProductivityScoreCard = ({
  productivityScore,
  contaninerClassName,
  chartConfig,
  compact,
  valueColor,
}) => {
  const productivityScoreValue = Number(productivityScore.replace('%', ''));

  if (compact) {
    return (
      <StatCard
        title="PRODUCTIVITY SCORE"
        value={
          valueColor ? (
            <span style={{ color: valueColor }}>{productivityScore}</span>
          ) : (
            productivityScore
          )
        }
        contaninerClassName={contaninerClassName}
        icon={<FiTrendingUp size={14} color="var(--rose-600)" />}
        iconBg="rose-100"
        compact
      />
    );
  }

  return (
    <StatCard
      title="PRODUCTIVITY SCORE"
      value={productivityScore}
      trend={{ type: 'up' }}
      contaninerClassName={contaninerClassName}
    >
      <div style={{ width: '62px', height: '62px' }}>
        <Doughnut
          options={{
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            cutout: '10%',
            tooltip: {
              enabled: false,
            },
          }}
          data={{
            labels: ['', ''],
            datasets: [
              {
                data: [productivityScoreValue, 100 - productivityScoreValue],
                backgroundColor: chartConfig?.backgroundColor || [
                  '#121F5C',
                  'white',
                ],
              },
            ],
          }}
        />
      </div>
    </StatCard>
  );
};

export const TotalTimeTrackedCard = ({
  totalTimeTracked,
  contaninerClassName,
  compact,
}) => {
  if (compact) {
    return (
      <StatCard
        title="TOTAL TIME TRACKED"
        value={totalTimeTracked}
        contaninerClassName={contaninerClassName}
        icon={<SvgIcon src={SvgIconSrc.stopwatch} size={14} />}
        iconBg="blue-100"
        compact
      />
    );
  }

  return (
    <StatCard
      title="TOTAL TIME TRACKED"
      value={totalTimeTracked}
      contaninerClassName={contaninerClassName}
    >
      <SvgIcon src={SvgIconSrc.uptrend} className={styles.trendIcon} />
    </StatCard>
  );
};

export const IdleTimeCard = ({ idleTime, contaninerClassName, compact }) => {
  if (compact) {
    return (
      <StatCard
        title="IDLE / REST"
        value={idleTime}
        contaninerClassName={contaninerClassName}
        icon={<FiCoffee size={14} color="var(--orange-600)" />}
        iconBg="orange-100"
        compact
      />
    );
  }

  return (
    <StatCard
      title="IDLE / REST"
      value={idleTime}
      contaninerClassName={contaninerClassName}
    >
      <SvgIcon src={SvgIconSrc.downtrend} className={styles.downtrendIcon} />
    </StatCard>
  );
};

export const ActiveTimeCard = ({ activeTime, contaninerClassName }) => {
  return (
    <StatCard
      title="ACTIVE TIME"
      value={activeTime}
      contaninerClassName={contaninerClassName}
      icon={<FiClock size={14} color="var(--success-600)" />}
      iconBg="success-100"
      compact
    />
  );
};

export const IdlePercentCard = ({ idlePercent, contaninerClassName }) => {
  return (
    <StatCard
      title="IDLE %"
      value={idlePercent}
      contaninerClassName={contaninerClassName}
      icon={<FiPercent size={14} color="var(--purple-600)" />}
      iconBg="purple-100"
      compact
    />
  );
};

export const ScreenshotsCard = ({
  screenshotsLabel,
  contaninerClassName,
  onClick,
}) => {
  return (
    <StatCard
      title="SCREENSHOTS"
      value={screenshotsLabel}
      contaninerClassName={contaninerClassName}
      icon={<FiImage size={14} color="var(--blue-600)" />}
      iconBg="blue-100"
      compact
    >
      {onClick && (
        <button
          type="button"
          className={styles.statTileAction}
          onClick={onClick}
        >
          View
        </button>
      )}
    </StatCard>
  );
};
